var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import DOMPurify from "dompurify";
var ALLOWED_HTML_TAGS = [
    "p",
    "br",
    "div",
    "span",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "s",
    "ul",
    "ol",
    "li",
    "blockquote",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "a",
    "img",
];
var ALLOWED_HTML_ATTRIBUTES = [
    "href",
    "title",
    "src",
    "alt",
    "style",
];
var ALLOWED_HTML_URI_PATTERN = /^(?:(?:https?):\/\/|\/(?!\/)|#)/i;
var ALLOWED_IMAGE_SRC_PATTERN = /^(?:https:\/\/|\/(?!\/))/i;
var SAFE_HEX_COLOR_PATTERN = /^#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
var getSafeInlineStyle = function (style) {
    for (var _i = 0, _a = style.split(";"); _i < _a.length; _i++) {
        var declaration = _a[_i];
        var separatorIndex = declaration.indexOf(":");
        if (separatorIndex === -1)
            continue;
        var property = declaration.slice(0, separatorIndex).trim().toLowerCase();
        var value = declaration.slice(separatorIndex + 1).trim();
        if (property === "color" && SAFE_HEX_COLOR_PATTERN.test(value)) {
            return "color: ".concat(value, ";");
        }
    }
    return "";
};
var sanitizeRestrictedAttributes = function (currentNode, hookEvent) {
    if (hookEvent.attrName === "src" &&
        currentNode.tagName.toLowerCase() === "img" &&
        !ALLOWED_IMAGE_SRC_PATTERN.test(hookEvent.attrValue)) {
        hookEvent.keepAttr = false;
        return;
    }
    if (hookEvent.attrName !== "style")
        return;
    var safeStyle = getSafeInlineStyle(hookEvent.attrValue);
    if (!safeStyle) {
        hookEvent.keepAttr = false;
        return;
    }
    hookEvent.attrValue = safeStyle;
};
var hardenAllowedImages = function (currentNode) {
    if (currentNode.tagName.toLowerCase() !== "img")
        return;
    currentNode.setAttribute("loading", "lazy");
    currentNode.setAttribute("decoding", "async");
    currentNode.setAttribute("referrerpolicy", "no-referrer");
};
export var sanitizeFormHtml = function (html) {
    DOMPurify.addHook("uponSanitizeAttribute", sanitizeRestrictedAttributes);
    DOMPurify.addHook("afterSanitizeAttributes", hardenAllowedImages);
    try {
        return DOMPurify.sanitize(html, {
            ALLOWED_TAGS: __spreadArray([], ALLOWED_HTML_TAGS, true),
            ALLOWED_ATTR: __spreadArray([], ALLOWED_HTML_ATTRIBUTES, true),
            ALLOWED_URI_REGEXP: ALLOWED_HTML_URI_PATTERN,
            ALLOW_ARIA_ATTR: false,
            ALLOW_DATA_ATTR: false,
            SANITIZE_DOM: true,
            SANITIZE_NAMED_PROPS: true,
        });
    }
    finally {
        DOMPurify.removeHook("uponSanitizeAttribute", sanitizeRestrictedAttributes);
        DOMPurify.removeHook("afterSanitizeAttributes", hardenAllowedImages);
    }
};
